import {
  Component,
  inject,
  signal,
  HostListener,
  computed,
} from '@angular/core';

import { Router, RouterModule } from '@angular/router';
import { UserMenuComponent } from '@sandbox-platform/shared-ui';
import { MobileMenuComponent } from './mobile-menu.component';
import { MobileMenuButtonComponent } from './mobile-menu-button.component';
import { ExpertDesktopMenuComponent } from './desktop-menu.component';
import {
  NavMobileMenuLinkConfig,
  SwitchboardButtonComponent,
} from '@sandbox-platform/shared-ui';
import { AuthStore } from '@sandbox-platform/shared-ui';

const MOBILE_NAVIGATION_ITEMS: NavMobileMenuLinkConfig[] = [
  {
    routerLink: '/dashboard',
    label: 'Dashboard',
    iconPath:
      'M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z',
    exact: true,
  },
  {
    routerLink: '/expert',
    label: 'Experts',
    iconPath:
      'M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z',
  },
  {
    routerLink: '/personnel',
    label: 'Personnel',
    iconPath:
      'M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z',
  },
  {
    routerLink: '/custom-attributes',
    label: 'Custom Attributes',
    iconPath:
      'M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01',
  },
  {
    routerLink: '/expert/reports',
    label: 'Expert Reports',
    iconPath:
      'M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z',
  },
  {
    routerLink: '/attendance-tracking',
    label: 'Attendance Tracking',
    iconPath:
      'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4',
  },
  {
    routerLink: '/attendance',
    label: 'Attendance',
    iconPath:
      'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4',
  },
  {
    routerLink: '/attendance/reports',
    label: 'Attendance Reports',
    iconPath:
      'M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z',
  },
  {
    routerLink: '/referrals',
    label: 'Referrals',
    iconPath:
      'M8 7h8m-8 4h8m-8 4h5M5 3h14a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2z',
  },
  {
    routerLink: '/commissions',
    label: 'Commissions',
    iconPath:
      'M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z',
  },
  {
    routerLink: '/commission-invoices',
    label: 'Commission Invoices',
    iconPath:
      'M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z',
  },
  {
    routerLink: '/commission-payments',
    label: 'Commission Payments',
    iconPath:
      'M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z',
  },
  {
    routerLink: '/commission-rules',
    label: 'Commission Rules',
    iconPath: 'M17 13l-5 5m0 0l-5-5m5 5V6',
  },
  {
    routerLink: '/commission-settings',
    label: 'Commission Settings',
    iconPath:
      'M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z M15 12a3 3 0 11-6 0 3 3 0 016 0z',
  },
  {
    routerLink: '/organizations',
    label: 'Organizations',
    iconPath:
      'M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4',
  },
  {
    routerLink: '/industries',
    label: 'Industries',
    iconPath:
      'M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z',
  },
  {
    routerLink: '/industries/hierarchy',
    label: 'Industries Hierarchy',
    iconPath:
      'M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4',
  },
  {
    routerLink: '/api-token-settings',
    label: 'API Token Settings',
    iconPath:
      'M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z',
  },
  {
    routerLink: '/attendance-settings',
    label: 'Attendance Settings',
    iconPath:
      'M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z M15 12a3 3 0 11-6 0 3 3 0 016 0z',
  },
];

@Component({
  standalone: true,
  imports: [
    RouterModule,
    UserMenuComponent,
    MobileMenuComponent,
    ExpertDesktopMenuComponent,
    SwitchboardButtonComponent,
    MobileMenuButtonComponent,
  ],
  selector: 'lib-expert-header',
  template: `
    <header
      class="bg-gray-900 shadow-lg border-b border-gray-700 w-full relative z-50 text-white"
    >
      <div class="px-4 sm:px-6 lg:px-8">
        <div
          class="flex flex-wrap md:flex-nowrap items-center gap-y-4 gap-x-6 md:gap-x-8 md:justify-between min-h-[4rem] py-3"
        >
          <!-- Logo/Brand -->
          <div class="order-1 flex items-center gap-x-3 min-w-0">
            <lib-switchboard-button
              variant="dark"
              (buttonClick)="goToSwitchboard()"
            />

            <!-- Company logo -->
            <img
              src="./banner.jpg"
              alt="SNDBX Platform"
              class="hidden h-10 w-auto mr-3 sm:block animate-fade-in"
            />

            <h1
              class="hidden lg:block text-base xl:text-lg font-semibold text-white truncate"
            >
              Experts Console
            </h1>
          </div>

          <!-- Desktop Navigation -->
          <lib-expert-desktop-menu
            class="order-3 w-full md:order-2 md:w-auto md:flex-1"
          />

          <!-- Right side: Mobile menu button + User Menu -->
          <div
            class="order-2 md:order-3 flex items-center justify-end space-x-4 ml-auto md:ml-0"
          >
            <!-- Mobile menu button -->
            <lib-mobile-menu-button
              [isOpen]="isMobileMenuOpen()"
              (toggle)="toggleMobileMenu()"
            />

            <!-- User Menu - Hidden on mobile -->
            <div class="hidden md:block">
              <lib-user-menu [profileHandler]="goToProfileHandler" />
            </div>
          </div>
        </div>
      </div>

      <!-- Mobile Menu Component -->
      <lib-expert-mobile-menu
        [isOpen]="isMobileMenuOpen()"
        [navigationItems]="mobileNavigationItems()"
        (close)="closeMobileMenu()"
      />
    </header>
  `,
  styles: [
    `
      :host {
        display: block;
      }

      .animate-fade-in {
        opacity: 0;
        animation: fadeIn 0.8s ease-in-out forwards;
      }

      @keyframes fadeIn {
        from {
          opacity: 0;
        }
        to {
          opacity: 1;
        }
      }
    `,
  ],
})
export class ExpertHeaderComponent {
  private readonly router = inject(Router);
  readonly authStore = inject(AuthStore);

  isMobileMenuOpen = signal(false);

  readonly mobileNavigationItems = computed<NavMobileMenuLinkConfig[]>(() =>
    MOBILE_NAVIGATION_ITEMS.filter((item) =>
      this.authStore.canAccessExpertRoute(item.routerLink)
    )
  );

  goToDashboard(): void {
    this.router.navigate(['/dashboard']);
  }

  goToSwitchboard(): void {
    window.location.href = '/auth/switchboard';
  }

  readonly goToProfileHandler = () => {
    this.router.navigate(['/profile'], {
      state: {
        returnUrl: this.router.url,
      },
    });
  };

  toggleMobileMenu() {
    this.isMobileMenuOpen.update((value) => !value);
  }

  closeMobileMenu() {
    this.isMobileMenuOpen.set(false);
  }

  // Close menu when clicking outside (escape key)
  @HostListener('document:keydown.escape')
  onEscapeKey() {
    if (this.isMobileMenuOpen()) {
      this.closeMobileMenu();
    }
  }

  // Close menu on window resize to desktop size
  @HostListener('window:resize')
  onResize() {
    if (window.innerWidth >= 768 && this.isMobileMenuOpen()) {
      this.closeMobileMenu();
    }
  }
}
